<div class="panel">
  <div class="panel__header">
    <span class="panel__header__title">{{Translate('Setup Undercarriage on Equipment')}}</span>
  </div>
  <mat-horizontal-stepper (selectionChange)="stepChangedManually($event)" [selectedIndex]="_selectedIndex" [linear]="false">
    <mat-step label="{{Translate('Select Equipment')}}">
      <div class="step-container">
        <div class="row">
          <div class="col-md-3">
            <form *ngIf="!_lockEquipment">
              <mat-form-field class="setup-form-full-width">
                <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer" placeholder="{{Translate('Select Customer')}}">
                  <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
                    {{ customer.Title }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="setup-form-full-width">
                <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobsite" placeholder="{{Translate('Select Job Site')}}">
                  <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                    {{ jobsite.Title }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="setup-form-full-width">
                <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
                  <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                    {{ equipment.Serial+ ' : ' + equipment.Unit }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
            <mat-card color="warning" *ngIf="_lockEquipment">{{Translate('By changing equipment you will lose all your inputs!')}} <button (click)="_lockEquipment = false" mat-icon-button> {{Translate('Unlock')}} <mat-icon aria="unlock">lock_open</mat-icon></button> </mat-card>
            <table *ngIf="_currentSelection.equipment.Id != 0" class="table table-striped">
              <thead>
                <tr>
                  <th>
                    {{Translate('Make')}}
                  </th>
                  <th>
                    {{Translate('Model')}}
                  </th>
                  <th>
                    {{Translate('Family')}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{_currentSelection.equipment.Make.Title}}
                  </td>
                  <td>
                    {{_currentSelection.equipment.Model.Title}}
                  </td>
                  <td>
                    {{_currentSelection.equipment.Family.Title}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--Step 0-->
        <div class="fix-control-area" >
          <div class="step-spacer" *ngIf="InspectionCount<=2">
            <a mat-raised-button routerLink="/setup-undercarriage">Cancel</a>
             <button mat-raised-button color="warn" (click)="nextStep()">{{Translate('Next')}}</button>
          <span class="step-validation-text">
            <mat-error class="step-error" *ngIf="!StepValidation(0).OperationSucceed">{{StepValidation(0).LastMessage}}</mat-error>
          </span>
          </div>
          <span style="color:red" *ngIf="InspectionCount>=2">{{'This equipment has more than 2 inspections associated with it. You cannot modify UnderCarriage details after this point. Please contact support if you need to make changes.' | translate | async}}</span>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{Translate('Chain & Frame Details')}}">
      <div class="step-container">
        <div class="row box">
          <div class="col-md-6 setup-on-eq-system-box">
            <!--Left Chain-->
            <div class="row">
              <div class="col-md-3 system-img">
                <div>
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Left Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
                <div class="divbuttonhandler">
                  <div class="copybutton">
                    <button (click)="copySystemClicked(1,2)" mat-raised-button class="copybutton">{{Translate('Copy to All')}}</button>
                  </div>
                  <div class="copybutton copybuttondiv">
                    <button (click)="copySystemClicked(1,1)" mat-raised-button class="copybutton">{{Translate('Copy to Right')}}</button>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Left Chain')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field style="padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftChainSerial" [(ngModel)]="_leftChainSetup.Serial">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">
                      <mat-form-field style="flex: 1;" [color]="systemSmuDateValidation(1).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input matInput [matDatepicker]="leftChainDatepicker" placeholder="{{Translate('Date at Install')}}" [(ngModel)]="_leftChainSetup.InstallationDate" name="_leftChainSetupInstallationDate" [formControl]="leftChainSetupDateControl">
                        <mat-datepicker-toggle matSuffix [for]="leftChainDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #leftChainDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(1).OperationSucceed && systemSmuDateValidation(1).Id == 1">{{systemSmuDateValidation(1).LastMessage}}</mat-error>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="padding-right: 10px;" [color]="systemSmuDateValidation(1).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input type="number" matInput placeholder="{{Translate('SMU on Equipment at Install')}}" name="_leftChainSetupSmuAtInstall" [(ngModel)]="_leftChainSetup.SmuAtInstall">
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(1).OperationSucceed && systemSmuDateValidation(1).Id == 2">{{systemSmuDateValidation(1).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1;" class="setup-form-full-width" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Distance on Equipment at install')}}" name="_leftChainSetupTotalDistance" [(ngModel)]="_leftChainSetup.TotalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Historical Hours on Chain at Install')}}" name="_leftChainSetupHoursAtInstall" [(ngModel)]="_leftChainSetup.HoursAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(1).OperationSucceed && systemSmuDateValidation(1).Id == 3">{{systemSmuDateValidation(1).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Historical Distance on Chain at install')}}" name="_leftChainSetupHistoricalDistance" [(ngModel)]="_leftChainSetup.HistoricalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="(_currentSelection.equipment.ShowPropelHrsPerc)">
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1; padding-right: 10px;">
                        <input matInput placeholder="{{Translate('PMU on Equipment at install')}}" name="_leftChainPMUHoursAtInstall" [(ngModel)]="_leftChainSetup.PMUAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-6 setup-on-eq-system-box">
            <!--Right Chain-->
            <div class="row">
              <div class="col-md-3 system-img">
                <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Left Chain">
                <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Right Chain')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field style="padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_rightChainSerial" [(ngModel)]="_rightChainSetup.Serial">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">
                      <mat-form-field style="flex: 1;" [color]="systemSmuDateValidation(2).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input matInput [matDatepicker]="rightChainDatepicker" placeholder="{{Translate('Date at Install')}}" [(ngModel)]="_rightChainSetup.InstallationDate" name="_rightChainSetupInstallationDate" [formControl]="rightChainSetupDateControl">
                        <mat-datepicker-toggle matSuffix [for]="rightChainDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #rightChainDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(2).OperationSucceed && systemSmuDateValidation(2).Id == 1">{{systemSmuDateValidation(2).LastMessage}}</mat-error>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width: 50%;">
                      <mat-form-field style="padding-right: 10px;" [color]="systemSmuDateValidation(2).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input type="number" matInput placeholder="{{Translate('SMU on Equipment at Install')}}" name="_rightChainSetupSmuAtInstall" [(ngModel)]="_rightChainSetup.SmuAtInstall">
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(2).OperationSucceed && systemSmuDateValidation(2).Id == 2">{{systemSmuDateValidation(2).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Distance on Equipment at install')}}" name="_rightChainSetupTotalDistance" [(ngModel)]="_rightChainSetup.TotalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Historical Hours on Chain at Install')}}" name="_rightChainSetupHoursAtInstall" [(ngModel)]="_rightChainSetup.HoursAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(2).OperationSucceed && systemSmuDateValidation(2).Id == 3">{{systemSmuDateValidation(2).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Historical Distance on Chain at install')}}" name="_rightChainSetupHistoricalDistance" [(ngModel)]="_rightChainSetup.HistoricalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="(_currentSelection.equipment.ShowPropelHrsPerc)">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('PMU on Equipment at install')}}" name="_rightChainPMUHoursAtInstall" [(ngModel)]="_rightChainSetup.PMUAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;"></div>
                  </div>
                </form>
              </div>
            </div>
            <!--<div class="row height-36"></div>-->
          </div>
        </div>
        <div class="row box">
          <div class="col-md-6 setup-on-eq-system-box">
            <!--Left Frame-->
            <div class="row">
              <div class="col-md-3 system-img">
                <div>
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Right Frame">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                </div>
                <div class="divbuttonhandler">
                  <button (click)="copySystemClicked(3,1)" mat-raised-button class="copybutton">{{Translate('Copy to Right')}}</button>
                </div>
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Left Frame')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field style="padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftFrameSerial" [(ngModel)]="_leftFrameSetup.Serial">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">
                      <mat-form-field style="flex: 1;" [color]="systemSmuDateValidation(3).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input matInput [matDatepicker]="leftFrameDatepicker" placeholder="{{Translate('Date at Install')}}" [(ngModel)]="_leftFrameSetup.InstallationDate" name="_leftFrameSetupInstallationDate" [formControl]="leftFrameSetupDateControl">
                        <mat-datepicker-toggle matSuffix [for]="leftFrameDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #leftFrameDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(3).OperationSucceed && systemSmuDateValidation(3).Id == 1">{{systemSmuDateValidation(3).LastMessage}}</mat-error>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Budget Life (Hrs)')}}" name="_leftFrameBudgetLife" [(ngModel)]="_leftFrameSetup.BudgetLife">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Budget Distance (Km)')}}" name="_leftFrameBudgetDistance" [(ngModel)]="_leftFrameSetup.BudgetDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" [color]="systemSmuDateValidation(3).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input type="number" matInput placeholder="{{Translate('SMU on Equipment at Install')}}" name="_leftFrameSetupSmuAtInstall" [(ngModel)]="_leftFrameSetup.SmuAtInstall">
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(3).OperationSucceed && systemSmuDateValidation(3).Id == 2">{{systemSmuDateValidation(3).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Distance on Equipment at install')}}" name="_leftFrameSetupTotalDistance" [(ngModel)]="_leftFrameSetup.TotalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Historical Hours on Frame at Install')}}" name="_leftFrameSetupHoursAtInstall" [(ngModel)]="_leftFrameSetup.HoursAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Historical Distance on Frame at install')}}" name="_leftFrameSetupHistoricalDistance" [(ngModel)]="_leftFrameSetup.HistoricalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="(_currentSelection.equipment.ShowPropelHrsPerc)">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('PMU on Equipment at install')}}" name="_leftFramePMUHoursAtInstall" [(ngModel)]="_leftFrameSetup.PMUAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(3).OperationSucceed && systemSmuDateValidation(3).Id == 3">{{systemSmuDateValidation(3).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;"></div>
                  </div>
                  <div style="display: flex; flex-direction: row; " >
                    <div style="display: flex; flex-direction: column; width: 50%;" *ngIf="_currentSelection.equipment.Family.EnableFrameConfiguration">
                      <label>{{Translate('Frame Configuration')}}</label>
                      <mat-radio-group name="_leftFrameSetupframeConfig" [(ngModel)]="_leftFrameSetup.frameConfig" (change)="LeftFrameConfigChange($event)">
                        <mat-radio-button [value]="1">{{Translate('Straight')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Toe Out')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div style="display: flex; flex-direction: column; width: 50%;" *ngIf="_currentSelection.equipment.Family.EnableCannonType">
                      <label>{{Translate('Cannon Type')}}</label>
                      <mat-radio-group name="_leftFrameSetupcannonType" [(ngModel)]="_leftFrameSetup.cannonType" (change)="LeftFrameCannonChange($event)">
                        <mat-radio-button [value]="1">{{Translate('Cast')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Fabricated')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-6 setup-on-eq-system-box">
            <!--Right Frame-->
            <div class="row">
              <div class="col-md-3 system-img">
                <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Right Frame">
                <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
              </div>
              <div class="col-md-9">
                <h4 class="colorGreen">
                  {{Translate('Right Frame')}}
                </h4>
                <form>
                  <div style="display: flex; align-content: space-between;">
                    <div style="width: 50%;">
                      <mat-form-field style="padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Serial Number')}}" name="_rightFrameSerial" [(ngModel)]="_rightFrameSetup.Serial">
                      </mat-form-field>
                    </div>
                    <div style="width: 50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" [color]="systemSmuDateValidation(4).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input matInput [matDatepicker]="rightFrameDatepicker" placeholder="{{Translate('Date at Install')}}" [(ngModel)]="_rightFrameSetup.InstallationDate" name="_rightFrameSetupInstallationDate" [formControl]="rightFrameSetupDateControl">
                        <mat-datepicker-toggle matSuffix [for]="rightFrameDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #rightFrameDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(4).OperationSucceed && systemSmuDateValidation(4).Id == 1">{{systemSmuDateValidation(4).LastMessage}}</mat-error>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Budget Life')}} (Hrs)" name="_rightFrameBudgetLife" [(ngModel)]="_rightFrameSetup.BudgetLife">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('Budget Distance(Km)')}}" name="_rightFrameBudgetDistance" [(ngModel)]="_rightFrameSetup.BudgetDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1; padding-right: 10px;" [color]="systemSmuDateValidation(4).OperationSucceed ? 'primary' : 'warn'" class="setup-form-full-width">
                        <input type="number" matInput placeholder="{{Translate('SMU on Equipment at Install')}}" name="_rightFrameSetupSmuAtInstall" [(ngModel)]="_rightFrameSetup.SmuAtInstall">
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(4).OperationSucceed && systemSmuDateValidation(4).Id == 2">{{systemSmuDateValidation(4).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Distance on Equipment at install')}}" name="_rightFrameSetupTotalDistance" [(ngModel)]="_rightFrameSetup.TotalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1; padding-right: 10px;">
                        <input matInput placeholder="{{Translate('Historical Hours on Frame at Install')}}" name="_rightFrameSetupHoursAtInstall" [(ngModel)]="_rightFrameSetup.HoursAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                    </div>
                    <div style="width:50%;">
                      <mat-form-field class="setup-form-full-width" style="flex: 1;" *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                        <input matInput placeholder="{{Translate('Historical Distance on Frame at install')}}" name="_rightFrameSetupHistoricalDistance" [(ngModel)]="_rightFrameSetup.HistoricalDistance">
                        <span matSuffix>{{Translate('Km')}}</span>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="display: flex;" *ngIf="(_currentSelection.equipment.ShowPropelHrsPerc)">
                    <div style="width:50%;">
                      <mat-form-field style="flex: 1;" class="setup-form-full-width">
                        <input matInput placeholder="{{Translate('PMU on Equipment at install')}}" name="_rightFramePMUHoursAtInstall" [(ngModel)]="_rightFrameSetup.PMUAtInstall">
                        <span matSuffix>{{Translate('Hrs')}}</span>
                      </mat-form-field>
                      <mat-error *ngIf="!systemSmuDateValidation(4).OperationSucceed && systemSmuDateValidation(4).Id == 3">{{systemSmuDateValidation(4).LastMessage}}</mat-error>
                    </div>
                    <div style="width:50%;"></div>
                  </div>
                  <div style="display: flex; flex-direction: row;" *ngIf="_currentSelection.equipment.Family.EnableFrameConfiguration">
                    <div style="display: flex; flex-direction: column; width: 50%;">
                      <label>{{Translate('Frame Configuration')}}</label>
                      <mat-radio-group name="_rightFrameSetupframeConfig" [(ngModel)]="_rightFrameSetup.frameConfig" (change)="RightFrameConfigChange($event)">
                        <mat-radio-button [value]="1">{{Translate('Straight')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Toe Out')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div style="display: flex; flex-direction: column; width: 50%;">
                      <label>{{Translate('Cannon Type')}}</label>
                      <mat-radio-group name="_rightFrameSetup.cannonType" [(ngModel)]="_rightFrameSetup.cannonType" (change)="RightFrameCannonChange($event)">
                        <mat-radio-button [value]="1">{{Translate('Cast')}}</mat-radio-button>
                        <mat-radio-button [value]="2">{{Translate('Fabricated')}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--Step 1-->
        <div class="fix-control-area">
          <button mat-button matStepperPrevious>{{Translate('Back')}}</button> <button mat-raised-button color="warn" (click)="nextStep()">{{Translate('Next')}}</button>
          <span class="step-validation-text">
            <mat-error class="step-error" *ngIf="!StepValidation(1).OperationSucceed">{{StepValidation(1).LastMessage}}</mat-error>
          </span>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{Translate('Components')}}">
      <div class="step-container">
        <p *ngIf="!_itIsUpdate">{{Translate('This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different')}}</p>
        <p *ngIf="_itIsUpdate">{{Translate('After you have submitted the data first time round, you are unable to setup components on both sides')}}</p>
        <mat-radio-group (change)="sideChanged($event)" [(ngModel)]="_selectedSide">
          <mat-radio-button [disabled]="disableBoth()" [value]="3">{{Translate('Both')}}</mat-radio-button>
          <mat-radio-button *ngIf="UCSetupType==1 || _itIsUpdate==true " [value]="1">{{Translate('Left')}}</mat-radio-button>
          <mat-radio-button *ngIf="UCSetupType==1 || _itIsUpdate==true" [value]="2">{{Translate('Right')}}</mat-radio-button>
        </mat-radio-group>

        <span *ngIf="UCSetupType!=1" style="margin-left: 15%;font-weight: 700;font-size: large;">Please select any component for this equipment that are marked with a <mat-icon aria-hidden="false" aria-label="Example home icon" style="color:red">warning</mat-icon>To add components click on the tabs with + </span>
        <div class="row" *ngIf="_selectedSide != 3">
          <!--Left and Right Sides-->
          <mat-tab-group (selectedTabChange)="sideTabChanged($event)" [selectedIndex]="_selectedSide == 1 ? 0 : 1">
            <mat-tab label="Left">
              <div class="row" *ngIf="_selectedSide != 3">
                <!--Both Sides Selected shows left only-->
                <!--Chain components-->
                <div class="col-md-12">
                  <h4>
                    {{Translate('Chain')}}
                  </h4>
                  <p>
                    {{Translate('Please add the components which will go on the chain.')}}
                  </p>
                  <div class="button-row">
                    <button (click)="addComponent(1,230)" [disabled]="checkTemplateForCompartTypeButton(1,230)" mat-raised-button>+ {{Translate('Link')}}</button>
                    <button (click)="addComponent(1,231)" [disabled]="checkTemplateForCompartTypeButton(1,231)" mat-raised-button>+ {{Translate('Bushing')}}</button>
                    <button (click)="addComponent(1,232)" [disabled]="checkTemplateForCompartTypeButton(1,232)" mat-raised-button>+ {{Translate('Shoe')}}</button>
                    <button (click)="addComponent(1,240)" [disabled]="checkTemplateForCompartTypeButton(1,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button>
                  </div>

                  <div style="text-align: center;">
                    <span class="step-validation-text">
                      <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
                    </span>
                  </div>
                  <!-- <div style="padding: 16px">
                      <mat-checkbox [(ngModel)]="bShowAllParts">Show All Parts</mat-checkbox>
                  </div> -->
                  <div style="padding: 16px" *ngIf="UCSetupType==1">
                    <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">Show Parts Ids</mat-checkbox>
                  </div>
                  <div class="row setup-table-row">
                    <div class="setup-component-table-container mat-elevation-z8">
                      <mat-table #table [dataSource]="leftchainTableDataSource">
                        <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                        <ng-container matColumnDef="delete">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element"><button [disabled]="!checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id,element)" (click)="removeElement(1,element)" mat-icon-button> <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id,element)" aria-label="close">close</mat-icon> </button> <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(1,element).OperationSucceed" aria-label="warning" title="{{validateComponent(1,element).LastMessage}}">warning</mat-icon> <mat-icon *ngIf="validateComponent(1,element).OperationSucceed" aria-label="success" title="{{validateComponent(1,element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon> </mat-cell>
                        </ng-container>

                        <!--<ng-container matColumnDef="listPosition">
      <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
  </ng-container>-->

                        <ng-container matColumnDef="Component">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element"> {{ Translate(element.Compart.CompartType.Title)}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Type">
                          <mat-header-cell *matHeaderCellDef> <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartList(element.Compart.CompartType.Id).length > 1 ) &&  (!validateComponent(1,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                              <mat-select (selectionChange)="CompartSelected($event, element)" disableRipple [ngModel]="shouldSelectDefault(element)">
                                <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartListFiltered(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                  <span style="color: #ed5565;">{{cmpart.CompartTitle}}</span>
                                  <span>{{cmpart.CompartNote ? ':' : ''}} {{Translate(cmpart.CompartNote)}}</span>&nbsp;
                                  <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-chip-list>
                              <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                            </mat-chip-list>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Pos">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn Bud %')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="element.BushTurnedPercent"  (ngModelChange)="getBushTurnedHours(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn H')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="bushTurnedHours" >
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="MLink">
                          <mat-header-cell *matHeaderCellDef> {{Translate('M/Link')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                                <mat-option [value]=0>Unknown</mat-option>
                                <mat-option [value]=1>M</mat-option>
                                <mat-option [value]=2>S</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobNum">
                          <mat-header-cell *matHeaderCellDef>{{Translate('Job #')}}   </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <input matInput [(ngModel)]="element.JobNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Size">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Size')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Grouser">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Grouser')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CleanerHoles">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cleaner Holes')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                              <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                                <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.OEMPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.MFRPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;&#13;&#13; If the component is used, you can enter the number of hours it has already done. &#13;&#13; If it is new the CMU will be 0.">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DOC">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                              <span matPrefix>$&nbsp;</span>
                              <!-- <span matSuffix>.00</span> -->
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="AssetNum">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                              <input matInput [(ngModel)]="element.AssetNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                      </mat-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="_selectedSide != 3">
                <!--Frame components-->
                <div class="col-md-12">
                  <h4>
                    {{Translate('Frame')}}
                  </h4>
                  <p>
                    {{Translate('Please add the components which will go on the frame.')}}
                  </p>
                  <div class="button-row">
                    <button (click)="addComponent(3,233)" [disabled]="checkTemplateForCompartTypeButton(3,233)" mat-raised-button>+ {{Translate('Idler')}}</button>
                    <button (click)="addComponent(3,236)" [disabled]="checkTemplateForCompartTypeButton(3,236)" mat-raised-button>+ {{Translate('Sprocket')}}</button>
                    <button (click)="addComponent(3,237)" [disabled]="checkTemplateForCompartTypeButton(3,237)" mat-raised-button>+ {{Translate('Guard')}}</button>
                    <!-- <button (click)="addComponent(3,240)" [disabled]="checkTemplateForCompartTypeButton(3,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button> -->
                    <button (click)="addComponent(3,234)" [disabled]="checkTemplateForCompartTypeButton(3,234)" mat-raised-button>+ {{Translate('Carrier Roller')}}</button>
                    <button (click)="addComponent(3,235)" [disabled]="checkTemplateForCompartTypeButton(3,235)" mat-raised-button>+ {{Translate('Track Roller')}}</button>
                    <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(3,446)" [disabled]="checkTemplateForCompartTypeButton(3,446)" mat-raised-button>+ {{Translate('Rear Idler')}}</button>
                    <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(3,417)" [disabled]="checkTemplateForCompartTypeButton(3,417)" mat-raised-button>+ {{Translate('Crawler Frame')}}</button>

                  </div>
                  <div style="text-align: center;">
                    <span class="step-validation-text">
                      <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
                    </span>
                  </div>
                  <div class="row setup-table-row">
                    <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                      <mat-table #table [dataSource]="leftframeTableDataSource">
                        <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                        <ng-container matColumnDef="delete">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <button [disabled]="!checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id,element)" (click)="removeElement(3,element)" mat-icon-button>
                              <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id,element)" aria-label="close">close</mat-icon>
                            </button>
                            <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(3,element).OperationSucceed" aria-label="warning" title="{{validateComponent(3,element).LastMessage}}">warning</mat-icon>
                            <mat-icon class="colorGreenDark component-status-icon" *ngIf="validateComponent(3,element).OperationSucceed" aria-label="success" title="{{validateComponent(3,element).LastMessage}}">check_circle</mat-icon>
                          </mat-cell>
                        </ng-container>

                        <!--<ng-container matColumnDef="listPosition">
      <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
  </ng-container>-->

                        <ng-container matColumnDef="Component">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element"> {{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Type">
                          <mat-header-cell *matHeaderCellDef> <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartList(element.Compart.CompartType.Id).length > 1 )  && (!validateComponent(3,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                              <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)" disableRipple>
                                <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                  <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  
                                  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>&nbsp;
                                  <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-chip-list>
                              <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                            </mat-chip-list>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Pos">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Position')}} </mat-header-cell>
                          <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="element.BushTurnedPercent" (ngModelChange)="getBushTurnedHours(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="BushTurnedHours">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MLink">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                                <mat-option [value]=0>Unknown</mat-option>
                                <mat-option [value]=1>M</mat-option>
                                <mat-option [value]=2>S</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobNum">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <input matInput [(ngModel)]="element.JobNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Size">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Grouser">
                          <mat-header-cell *matHeaderCellDef></mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="CleanerHoles">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                              <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                                <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.OEMPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.MFRPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;If the component is used, you can enter the number of hours it has already done.&#13;&#13;If it is new the CMU will be 0">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DOC">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                              <span matPrefix>$&nbsp;</span>
                              <!-- <span matSuffix>.00</span> -->
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="AssetNum">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Asset#')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                              <input matInput [(ngModel)]="element.AssetNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                      </mat-table>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Right">
              <div class="row" *ngIf="_selectedSide != 3">
                <!--Both Sides Selected shows left only-->
                <!--Chain components-->
                <div class="col-md-12">
                  <h4>
                    {{Translate('Chain')}}
                  </h4>
                  <p>
                    {{Translate('Please add the components which will go on the chain.')}}
                  </p>
                  <div class="button-row">
                    <button (click)="addComponent(2,230)" [disabled]="checkTemplateForCompartTypeButton(2,230)" mat-raised-button>+ {{Translate('Link')}}</button>
                    <button (click)="addComponent(2,231)" [disabled]="checkTemplateForCompartTypeButton(2,231)" mat-raised-button>+ {{Translate('Bushing')}}</button>
                    <button (click)="addComponent(2,232)" [disabled]="checkTemplateForCompartTypeButton(2,232)" mat-raised-button>+ {{Translate('Shoe')}}</button>
                    <button (click)="addComponent(2,240)" [disabled]="checkTemplateForCompartTypeButton(2,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button>
                  </div>

                  <div style="text-align: center;">
                    <span class="step-validation-text">
                      <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
                    </span>
                  </div>
                  <!-- <div style="padding: 16px">
                      <mat-checkbox [(ngModel)]="bShowAllParts">Show All Parts</mat-checkbox>
                  </div> -->
                  <div style="padding: 16px" *ngIf="UCSetupType==1">
                    <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">Show Parts Ids</mat-checkbox>
                  </div>

                  <div class="row setup-table-row">
                    <div class="setup-component-table-container mat-elevation-z8">
                      <mat-table #table [dataSource]="rightchainTableDataSource">
                        <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                        <ng-container matColumnDef="delete">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element"><button [disabled]="!checkTemplateForCompartRemoveFromList(2,element.Compart.CompartType.Id,element)" (click)="removeElement(2,element)" mat-icon-button> <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(2,element.Compart.CompartType.Id, element)" aria-label="close">close</mat-icon> </button> <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(2,element).OperationSucceed" aria-label="warning" title="{{validateComponent(2,element).LastMessage}}">warning</mat-icon> <mat-icon class="colorGreenDark component-status-icon" *ngIf="validateComponent(2,element).OperationSucceed" aria-label="success" title="{{validateComponent(2,element).LastMessage}}">check_circle</mat-icon> </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Component">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element"> {{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Type">
                          <mat-header-cell *matHeaderCellDef>  <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartListFiltered(element.Compart.CompartType.Id).length > 1 ) &&  (!validateComponent(2,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                              <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)" disableRipple>
                                <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartListFiltered(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                  <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  
                                  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>&nbsp;
                                  <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-chip-list>
                              <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                            </mat-chip-list>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Pos">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                        </ng-container>

                        <!-- <ng-container matColumnDef="BushTurnedBudgetLife">
      <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turned Life')}} </mat-header-cell>
      <mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
              <input matInput [(ngModel)]="element.BushTurnedBudgetLife">
          </mat-form-field>
      </mat-cell>
  </ng-container> -->

                        <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn Bud %')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="element.BushTurnedPercent" (ngModelChange)="getBushTurnedHours(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn H')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="bushTurnedHours">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MLink">
                          <mat-header-cell *matHeaderCellDef> {{Translate('M/Link')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                                <mat-option [value]=0>Unknown</mat-option>
                                <mat-option [value]=1>M</mat-option>
                                <mat-option [value]=2>S</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobNum">
                          <mat-header-cell *matHeaderCellDef>{{Translate('Job #')}}   </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <input matInput [(ngModel)]="element.JobNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="Size">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Size')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Grouser">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Grouser')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CleanerHoles">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cleaner Holes')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                              <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                                <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.OEMPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.MFRPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;If the component is used, you can enter the number of hours it has already done.&#13;&#13;If it is new the CMU will be 0">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DOC">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                              <span matPrefix>$&nbsp;</span>
                              <!-- <span matSuffix>.00</span> -->
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="AssetNum">
                          <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                              <input matInput [(ngModel)]="element.AssetNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                      </mat-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="_selectedSide != 3">
                <!--Frame components-->
                <div class="col-md-12">
                  <h4>
                    {{Translate('Frame')}}
                  </h4>
                  <p>
                    {{Translate('Please add the components which will go on the frame.')}}
                  </p>
                  <div class="button-row">
                    <button (click)="addComponent(4,233)" [disabled]="checkTemplateForCompartTypeButton(4,233)" mat-raised-button>+ {{Translate('Idler')}}</button>
                    <button (click)="addComponent(4,236)" [disabled]="checkTemplateForCompartTypeButton(4,236)" mat-raised-button>+ {{Translate('Sprocket')}}</button>
                    <button (click)="addComponent(4,237)" [disabled]="checkTemplateForCompartTypeButton(4,237)" mat-raised-button>+ {{Translate('Guard')}}</button>
                    <!-- <button (click)="addComponent(4,240)" [disabled]="checkTemplateForCompartTypeButton(4,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button> -->
                    <button (click)="addComponent(4,234)" [disabled]="checkTemplateForCompartTypeButton(4,234)" mat-raised-button>+ {{Translate('Carrier Roller')}}</button>
                    <button (click)="addComponent(4,235)" [disabled]="checkTemplateForCompartTypeButton(4,235)" mat-raised-button>+ {{Translate('Track Roller')}}</button>
                    <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(4,446)" [disabled]="checkTemplateForCompartTypeButton(4,446)" mat-raised-button>+ {{Translate('Rear Idler')}}</button>
                    <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(4,417)" [disabled]="checkTemplateForCompartTypeButton(4,417)" mat-raised-button>+ {{Translate('Crawler Frame')}}</button>

                  </div>
                  <div style="text-align: center;">
                    <span class="step-validation-text">
                      <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
                    </span>
                  </div>
                  <div class="row setup-table-row">
                    <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                      <mat-table #table [dataSource]="rightframeTableDataSource">
                        <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                        <ng-container matColumnDef="delete">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element"><button [disabled]="!checkTemplateForCompartRemoveFromList(4,element.Compart.CompartType.Id, element)" (click)="removeElement(4,element)" mat-icon-button> <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(4,element.Compart.CompartType.Id,element)" aria-label="close">close</mat-icon> </button> <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(4,element).OperationSucceed" aria-label="warning" title="{{validateComponent(4,element).LastMessage}}">warning</mat-icon> <mat-icon class="colorGreenDark component-status-icon" *ngIf="validateComponent(4,element).OperationSucceed" aria-label="success" title="{{validateComponent(4,element).LastMessage}}">check_circle</mat-icon> </mat-cell>
                        </ng-container>

                        <!--<ng-container matColumnDef="listPosition">
      <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
  </ng-container>-->

                        <ng-container matColumnDef="Component">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element"> {{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                        </ng-container>

                        co

                        <ng-container matColumnDef="Type">
                          <mat-header-cell *matHeaderCellDef> <span class="colorRed">{{Translate('Component')}} *</span> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartListFiltered(element.Compart.CompartType.Id).length > 1 ) &&  (!validateComponent(4,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                              <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)" disableRipple>
                                <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                  <!-- {{cmpart.CompartTitle}}   {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}} -->
                                  <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  
                                  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>&nbsp;
                                  <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-chip-list>
                              <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                            </mat-chip-list>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Pos">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Position')}} </mat-header-cell>
                          <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                        </ng-container>

                        <!-- <ng-container matColumnDef="BushTurnedBudgetLife">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
              <input matInput [(ngModel)]="element.BushTurnedBudgetLife">
          </mat-form-field>
      </mat-cell>
  </ng-container> -->

                        <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="element.BushTurnedPercent" (ngModelChange)="getBushTurnedHours(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="bushTurnedHours">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MLink">
                          <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                                <mat-option [value]=0>Unknown</mat-option>
                                <mat-option [value]=1>M</mat-option>
                                <mat-option [value]=2>S</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobNum">
                          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                              <input matInput [(ngModel)]="element.JobNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Size">
                          <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Grouser">
                          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                              <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CleanerHoles">
                          <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">


                              <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                                <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.OEMPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.MFRPartNo">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field>
                              <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;If the component is used, you can enter the number of hours it has already done.&#13;&#13;If it is new the CMU will be 0">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.DOC">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width">
                              <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                              <span matPrefix>$&nbsp;</span>
                              <!-- <span matSuffix>.00</span> -->
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="AssetNum">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Asset#')}}  </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                              <input matInput [(ngModel)]="element.AssetNum">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                      </mat-table>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="row" *ngIf="_selectedSide == 3">
          <!--Both Sides Selected shows left only-->
          <!--Chain components-->
          <div class="col-md-12">
            <h4>
              {{Translate('Chain')}}
            </h4>
            <p>
              {{Translate('Please add the components which will go on the chain.')}}
            </p>
            <div class="button-row">
              <button (click)="addComponent(1,230)" [disabled]="checkTemplateForCompartTypeButton(1,230)" mat-raised-button>+ {{Translate('Link')}}</button>
              <button (click)="addComponent(1,231)" [disabled]="checkTemplateForCompartTypeButton(1,231)" mat-raised-button>+ {{Translate('Bushing')}}</button>
              <button (click)="addComponent(1,232)" [disabled]="checkTemplateForCompartTypeButton(1,232)" mat-raised-button>+ {{Translate('Shoe')}}</button>
              <button (click)="addComponent(1,240)" [disabled]="checkTemplateForCompartTypeButton(1,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button>
            </div>

            <div style="text-align: center;">
              <span class="step-validation-text">
                <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
              </span>
            </div>
            <!-- <div style="padding: 16px">
                <mat-checkbox [(ngModel)]="bShowAllParts">Show All Parts</mat-checkbox>
            </div> -->
            <div style="padding: 16px" *ngIf="UCSetupType==1">
              <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">Show Parts Ids</mat-checkbox>
            </div>
            <div class="row setup-table-row">
              <div class="setup-component-table-container mat-elevation-z8">
                <mat-table #table [dataSource]="leftchainTableDataSource">
                  <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                  <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element"><button [disabled]="!checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id,element)" (click)="removeElement(1,element)" mat-icon-button> <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id,element)" aria-label="close">close</mat-icon> </button> <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(1,element).OperationSucceed" aria-label="warning" title="{{validateComponent(1,element).LastMessage}}">warning</mat-icon> <mat-icon *ngIf="validateComponent(1,element).OperationSucceed" aria-label="success" title="{{validateComponent(1,element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon> </mat-cell>
                  </ng-container>

                  <!--<ng-container matColumnDef="listPosition">
      <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
  </ng-container>-->

                  <ng-container matColumnDef="Component">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Type">
                    <mat-header-cell *matHeaderCellDef><span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <!-- <mat-form-field>
          <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)" disableRipple [value]="element.Compart.Id" name="cmpart">
              <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartListFiltered(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                   <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>
              </mat-option>
          </mat-select>
      </mat-form-field> -->

                      <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartListFiltered(element.Compart.CompartType.Id).length > 1 ) && (!validateComponent(1,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                        <mat-select (selectionChange)="CompartSelected($event, element)" disableRipple [ngModel]="shouldSelectDefault(element)">
                          <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartListFiltered(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                            <span style="color: #ed5565;">{{cmpart.CompartTitle}}</span>
                            <span>{{cmpart.CompartNote ? ':' : ''}} {{Translate(cmpart.CompartNote)}}</span>&nbsp;
                            <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-chip-list>
                        <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                      </mat-chip-list>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Pos">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                  </ng-container>

                  <!-- <ng-container matColumnDef="BushTurnedBudgetLife">
      <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turned Life')}} </mat-header-cell>
      <mat-cell *matCellDef="let element">
          <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
              <input matInput [(ngModel)]="element.BushTurnedBudgetLife">
          </mat-form-field>
      </mat-cell>
  </ng-container> -->

                  <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                    ma
                    <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn Bud %')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                        <input matInput [(ngModel)]="element.BushTurnedPercent" (ngModelChange)="getBushTurnedHours(element)">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> {{Translate('Bush Turn H')}} </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="bushTurnedHours">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                  <ng-container matColumnDef="MLink">
                    <mat-header-cell *matHeaderCellDef> {{Translate('M/Link')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                        <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                          <mat-option [value]=0>Unknown</mat-option>
                          <mat-option [value]=1>M</mat-option>
                          <mat-option [value]=2>S</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="JobNum">
                    <mat-header-cell *matHeaderCellDef>{{Translate('Job #')}}   </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                        <input matInput [(ngModel)]="element.JobNum">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Size">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Size')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                        <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                          <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Grouser">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Grouser')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                        <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                          <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="CleanerHoles">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Cleaner Holes')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">


                        <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                          <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                          <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.OEMPartNo">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.MFRPartNo">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>


                  <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;If the component is used, you can enter the number of hours it has already done.&#13;&#13;If it is new the CMU will be 0">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>


                  <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.DOC">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                        <span matPrefix>$&nbsp;</span>
                        <!-- <span matSuffix>.00</span> -->
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="AssetNum">
                    <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                        <input matInput [(ngModel)]="element.AssetNum">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                </mat-table>
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="_selectedSide == 3">
          <!--Frame components-->
          <div class="col-md-12">
            <h4>
              {{Translate('Frame')}}
            </h4>
            <p>
              {{Translate('Please add the components which will go on the frame.')}}
            </p>
            <div class="button-row">
              <button (click)="addComponent(3,233)" [disabled]="checkTemplateForCompartTypeButton(3,233)" mat-raised-button>+ {{Translate('Idler')}}</button>
              <button (click)="addComponent(3,236)" [disabled]="checkTemplateForCompartTypeButton(3,236)" mat-raised-button>+ {{Translate('Sprocket')}}</button>
              <button (click)="addComponent(3,237)" [disabled]="checkTemplateForCompartTypeButton(3,237)" mat-raised-button>+ {{Translate('Guard')}}</button>
              <!-- <button (click)="addComponent(3,240)" [disabled]="checkTemplateForCompartTypeButton(3,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button> -->
              <button (click)="addComponent(3,234)" [disabled]="checkTemplateForCompartTypeButton(3,234)" mat-raised-button>+ {{Translate('Carrier Roller')}}</button>
              <button (click)="addComponent(3,235)" [disabled]="checkTemplateForCompartTypeButton(3,235)" mat-raised-button>+ {{Translate('Track Roller')}}</button>
              <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(3,446)" [disabled]="checkTemplateForCompartTypeButton(3,446)" mat-raised-button>+ {{Translate('Rear Idler')}}</button>
              <button *ngIf="_currentSelection?.equipment?.Family?.Id == 203" (click)="addComponent(3,417)" [disabled]="checkTemplateForCompartTypeButton(3,417)" mat-raised-button>+ {{Translate('Crawler Frame')}}</button>

            </div>
            <div style="text-align: center;">
              <span class="step-validation-text">
                <mat-error style="background-color: #FF5353;color: white;" class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
              </span>
            </div>

            <div class="row setup-table-row">
              <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                <mat-table #table [dataSource]="leftframeTableDataSource">
                  <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
                  <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <button [disabled]="!checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id,element)" (click)="removeElement(3,element)" mat-icon-button>
                        <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id,element)" aria-label="close">close</mat-icon>
                      </button>
                      <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(3,element).OperationSucceed" aria-label="warning" title="{{validateComponent(3,element).LastMessage}}">warning</mat-icon>
                      <mat-icon *ngIf="validateComponent(3,element).OperationSucceed" aria-label="success" title="{{validateComponent(3,element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon>
                    </mat-cell>
                  </ng-container>

                  <!--<ng-container matColumnDef="listPosition">
      <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
  </ng-container>-->

                  <ng-container matColumnDef="Component">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Type">
                    <mat-header-cell *matHeaderCellDef>  <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field [ngStyle]="{'background-color':( (getAvailableCompartList(element.Compart.CompartType.Id).length > 1 )  && (!validateComponent(3,element).OperationSucceed))? '#FF5353' : 'transparent'}">
                        <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)">
                          <mat-option style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)" [value]="cmpart.Id" title="{{Translate(cmpart.CompartNote)}}">
                            <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span> 
                             <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>&nbsp;
                             <span *ngIf="cmpart.ComponentPitch != null" style="color: black">Pitch {{cmpart.ComponentPitch}} {{userUOM}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-chip-list>
                        <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}: {{element.Compart.MeasurementPointsNo}}</mat-chip>
                      </mat-chip-list>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Pos">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Position')}} </mat-header-cell>
                    <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="BushTurnedPercent" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                        <input matInput [(ngModel)]="element.BushTurnedPercent" (ngModelChange)="getBushTurnedHours(element)">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="BushTurnedHours" *ngIf="UCSetupType==1">
                          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                          <mat-cell *matCellDef="let element">
                            <mat-form-field *ngIf="element.Compart.CompartType.Id == 231">
                              <input matInput [(ngModel)]="bushTurnedHours">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                  <ng-container matColumnDef="MLink">
                    <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                        <mat-select name="Mlink" (selectionChange)="MLinkChange($event,element)" disableRipple [value]="element.MLink == undefind?0:element.MLink">
                          <mat-option [value]=0>Unknown</mat-option>
                          <mat-option [value]=1>M</mat-option>
                          <mat-option [value]=2>S</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="JobNum">
                    <mat-header-cell *matHeaderCellDef>   </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 230">
                        <input matInput [(ngModel)]="element.JobNum">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Size">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                        <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                          <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Grouser">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                        <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                          <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="CleanerHoles">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">

                        <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" [value]="element.HasCleanerHoles == undefind?0:element.HasCleanerHoles" disableRipple>
                          <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Brand" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                          <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>


                  <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.OEMPartNo">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds && UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.MFRPartNo">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="BudgetLife" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <input matInput [(ngModel)]="element.BudgetLife" (focusout)="budgetLifeChanged(element)">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>


                  <ng-container matColumnDef="HoursAtInstall" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('CMU')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.HoursAtInstall" matTooltipClass="cmu-tooltip" matTooltip="The Component Meter Units (CMU) is the current life of the component. &#13;&#13;If the component is used, you can enter the number of hours it has already done.&#13;&#13;If it is new the CMU will be 0">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="PMUAtInstall" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="DistanceBudget" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Distance Budget')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.DistanceBudget">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="DOC" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('DOC')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.DOC">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="InstallCost" *ngIf="UCSetupType==1">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.InstallCost" matTooltipClass="cmu-tooltip" matTooltip="This is the original cost of the component when first setup. &#13;&#13;&#13;&#13;  Future costs will be added through equipment actions.">
                        <span matPrefix>$&nbsp;</span>
                        <!-- <span matSuffix>.00</span> -->
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="AssetNum">
                    <mat-header-cell *matHeaderCellDef> {{Translate('Asset#')}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width" *ngIf="element.Compart.CompartType.Id == 233">
                        <input matInput [(ngModel)]="element.AssetNum">
                      </mat-form-field>
                    </mat-cell>
                  </ng-container>


                  <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                </mat-table>
              </div>
            </div>
          </div>
        </div>
        <div class="fix-control-area">
          <button mat-button matStepperPrevious>{{Translate('Back')}}</button>
          <button *ngIf="UCSetupType==1" mat-raised-button color="warn" (click)="nextStep()">{{Translate('Next')}}</button>

          <button *ngIf="UCSetupType!=1" mat-raised-button color="warn" (click)="nexStepBasic()">{{Translate('Submit')}}</button>
          <span class="step-validation-text">
            <mat-error class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
          </span>
          <!-- <button  (click)="logSystems()">log sys</button> -->
        </div>
      </div>
    </mat-step>


    <mat-step label="{{Translate('Review and Save')}}" *ngIf="UCSetupType==1">
      <div class="step-container">
        <div *ngIf="_selectedSide == 3">
          <!--Both-->
          <div class="row box padding-16" style="margin-right: -68px;margin-left: 0px; width: 100%;">
            <div class="col-md-12">
              <!--Left Chain-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width:100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Left Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Left Chain')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('HistoricalDistance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_leftChainSetup.Serial}}
                        </td>
                        <td>
                          {{_leftChainSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_leftChainSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_leftChainSetup.SmuAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftChainSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_leftChainSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_leftChainSetup.Result.LastMessage)" aria-label="error" title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_leftChainSetup.Result.LastMessage)" aria-label="error" title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_leftChainSetup.Result.OperationSucceed && _leftChainSetup.Id != 0" aria-label="check" title="{{_leftChainSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftChainSetup.Components">
                        <td>
                          {{ Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-12"  style="width:100%;">
              <!--Right Chain-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Right Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Right Chain')}}
                  </h3>
                  <table class="table table-sm" style="width: 60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_rightChainSetup.Serial}}
                        </td>
                        <td>
                          {{_rightChainSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_rightChainSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_rightChainSetup.SmuAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_rightChainSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_rightChainSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_rightChainSetup.Result.LastMessage)" aria-label="error" title="{{_rightChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_rightChainSetup.Result.LastMessage)" aria-label="error" title="{{_rightChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_rightChainSetup.Result.OperationSucceed && _rightChainSetup.Id" aria-label="check" title="{{_rightChainSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftChainSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
            <div class="col-md-12">
              <!--Left Frame-->
              <div class="row" style="margin-right: -68px; margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <!-- <img src="/Content/Images/frame.jpg" alt="Left Frame"> -->
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Left Chain">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Left Frame')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_leftFrameSetup.Serial}}
                        </td>
                        <td>
                          {{_leftFrameSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_leftFrameSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_leftFrameSetup.SmuAtInstall}}
                        </td>
                        <td>
                          {{_leftFrameSetup.BudgetLife}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftFrameSetup.BudgetDistance}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftFrameSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_leftFrameSetup.Result.OperationSucceed" aria-label="error" title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_leftFrameSetup.Result.LastMessage)" aria-label="error" title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_leftFrameSetup.Result.OperationSucceed && _leftFrameSetup.Id != 0" aria-label="check" title="{{_leftFrameSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftFrameSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <!--Right Frame-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Right Frame">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">

                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Right Frame')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('HistoricalDistance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_rightFrameSetup.Serial}}
                        </td>
                        <td>
                          {{_rightFrameSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_rightFrameSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_rightFrameSetup.SmuAtInstall}}
                        </td>
                        <td>
                          {{_rightFrameSetup.BudgetLife}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_rightFrameSetup.BudgetDistance}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_rightFrameSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_rightFrameSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_rightFrameSetup.Result.LastMessage)" aria-label="error" title="{{_rightFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_rightFrameSetup.Result.LastMessage)" aria-label="error" title="{{_rightFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_rightFrameSetup.Result.OperationSucceed && _rightFrameSetup.Id" aria-label="check" title="{{_rightFrameSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftFrameSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="_selectedSide != 3">
          <!--Left and Right-->
          <div class="row box padding-16" style="margin-right: -68px;margin-left: 0px; width:100%;">
            <div class="col-md-12">
              <!--Left Chain-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Left Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Left Chain')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_leftChainSetup.Serial}}
                        </td>
                        <td>
                          {{_leftChainSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_leftChainSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_leftChainSetup.SmuAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftChainSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_leftChainSetup.Result.OperationSucceed   && !checkIsShouldShowWarningMessage(_leftChainSetup.Result.LastMessage)" aria-label="error" title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_leftChainSetup.Result.LastMessage)" aria-label="error" title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_leftChainSetup.Result.OperationSucceed && _leftChainSetup.Id != 0" aria-label="check" title="{{_leftChainSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftChainSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <!--Right Chain-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Left Chain">
                  <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Right Chain')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_rightChainSetup.Serial}}
                        </td>
                        <td>
                          {{_rightChainSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_rightChainSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_rightChainSetup.SmuAtInstall}}
                        </td>
                        <td>
                          {{_rightChainSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_rightChainSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_rightChainSetup.Result.LastMessage)" aria-label="error" title="{{_rightChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_rightChainSetup.Result.LastMessage)" aria-label="error" title="{{_rightChainSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_rightChainSetup.Result.OperationSucceed && _rightChainSetup.Id != 0" aria-label="check" title="{{_rightChainSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _rightChainSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
            <div class="col-md-12">
              <!--Left Frame-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Left Frame">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Left Frame')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_leftFrameSetup.Serial}}
                        </td>
                        <td>
                          {{_leftFrameSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_leftFrameSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_leftFrameSetup.SmuAtInstall}}
                        </td>
                        <td>
                          {{_leftFrameSetup.BudgetLife}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftFrameSetup.BudgetDistance}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_leftFrameSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_leftFrameSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_leftFrameSetup.Result.LastMessage)" aria-label="error" title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_leftFrameSetup.Result.LastMessage)" aria-label="error" title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_leftFrameSetup.Result.OperationSucceed && _leftFrameSetup.Id" aria-label="check" title="{{_leftFrameSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped  table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _leftFrameSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <!--Right Frame-->
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-3 img-wrap">
                  <img *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Right Frame">
                  <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                </div>
                <div class="col-md-12">
                  <h3>
                    {{Translate('Right Frame')}}
                  </h3>
                  <table class="table table-sm" style="width:60%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Serial Number')}}
                        </td>
                        <td>
                          {{Translate('Hours at Install')}}
                        </td>
                        <td>
                          {{Translate('Date at Install')}}
                        </td>
                        <td>
                          {{Translate('Equip. SMU/Hourmeter at install')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Historical Distance')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody class="bold">
                      <tr>
                        <td>
                          {{_rightFrameSetup.Serial}}
                        </td>
                        <td>
                          {{_rightFrameSetup.HoursAtInstall}}
                        </td>
                        <td>
                          {{formatDate(_rightFrameSetup.InstallationDate)}}
                        </td>
                        <td>
                          {{_rightFrameSetup.SmuAtInstall}}
                        </td>
                        <td>
                          {{_rightFrameSetup.BudgetLife}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_rightFrameSetup.BudgetDistance}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{_rightFrameSetup.HistoricalDistance}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!_rightFrameSetup.Result.OperationSucceed && !checkIsShouldShowWarningMessage(_rightFrameSetup.Result.LastMessage)" aria-label="error" title="{{_rightFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorYellow" *ngIf="checkIsShouldShowWarningMessage(_rightFrameSetup.Result.LastMessage)" aria-label="error" title="{{_rightFrameSetup.Result.LastMessage}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="_rightFrameSetup.Result.OperationSucceed && _rightFrameSetup.Id" aria-label="check" title="{{_rightFrameSetup.Result.LastMessage}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="margin-right: -68px;margin-left: 0px; width: 100%;">
                <div class="col-md-12">
                  <table class="table table-striped table-responsive" style="width:100%;">
                    <thead>
                      <tr>
                        <td>
                          {{Translate('Type')}}
                        </td>
                        <td>
                        </td>
                        <td>
                          {{Translate('Brand')}}
                        </td>
                        <td>
                          {{Translate('Budget Life')}}
                        </td>
                        <td>
                          {{Translate('Hours at install')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('Distance Budget')}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{Translate('DOC')}}
                        </td>
                        <td>
                          {{Translate('Cost')}}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let component of _rightFrameSetup.Components">
                        <td>
                          {{Translate(component.Compart.CompartType.Title)}}: {{component.Compart.CompartTitle}}
                        </td>
                        <td>
                          {{showPosition(component)}}
                        </td>
                        <td>
                          {{component.Brand.Title}}
                        </td>
                        <td>
                          {{component.BudgetLife}}
                        </td>
                        <td>
                          {{component.HoursAtInstall}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DistanceBudget}}
                        </td>
                        <td *ngIf="_currentSelection.equipment.EnableDistTravelledTracking">
                          {{component.DOC}}
                        </td>
                        <td>
                          {{component.InstallCost}}
                        </td>
                        <td>
                          <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                          <mat-icon class="colorGreenDark" *ngIf="component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fix-control-area">
          <button mat-button [disabled]="_loading > 0 || _submitting" matStepperPrevious>{{Translate('Back')}}</button>
          <button *ngIf="!success" mat-raised-button color="warn" [class.loading]="_submitting" [disabled]="_loading > 0 || _submitting" (click)="nextStep()">{{Translate('Submit')}}</button>
          <button *ngIf="success && _leftChainSetup.Result.OperationSucceed && _rightChainSetup.Result.OperationSucceed && _leftFrameSetup.Result.OperationSucceed && _rightFrameSetup.Result.OperationSucceed" mat-raised-button color="warn" (click)="gottoEquipmentDetails()">{{Translate('Done')}}</button>
          <span class="step-validation-text">
            <mat-error class="step-error" *ngIf="!StepValidation(3).OperationSucceed">{{StepValidation(3).LastMessage}}</mat-error>
          </span>
          <!-- <button  (click)="logSystems()">log sys</button> -->
        </div>
      </div>
    </mat-step>



  </mat-horizontal-stepper>
  <mat-card *ngIf="_unsyncedId != 0">
    <span> {{Translate('This Equipment is matched with an inspection which has been done on mobile application!')}} </span><button mat-raised-button (click)="goToUnsynced()">{{Translate('Unsynced Inspection')}}</button>
  </mat-card>
</div>
<!--<mat-progress-bar class="loading-bar" *ngIf="_loading" mode="indeterminate" value="50"></mat-progress-bar>-->
